module.exports = require("markdown-it");


//////////////////
// WEBPACK FOOTER
// external "markdown-it"
// module id = 9
// module chunks = 0 1 2